export default __webpack_public_path__ + "static/media/Fresh-and-Clean.deaa7cc9.gif";